export const DependentAddSource = {
  ONBOARD_CLI: "onboard-cli",
  BULK_UPLOAD: "bulk-upload",
  ADMIN: "admin",
  ORG_ADMIN: "org-admin",
  USER_ONBOARD_FLOW: "user-onboard-flow",
  USER_PROFILE: "user-profile",
};
